var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
import Button from '../../button/Button';
var StyledInnerWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 auto;\n"])));
StyledInnerWrapper.displayName = 'ModalWrapper';
var StyledModalTitle = styled.h3(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-weight: bold;\n  ", ";\n  margin-top: 40px;\n"])), function (props) {
  return props.color;
});
StyledModalTitle.displayName = 'Modal Title';
var StyledModalDescription = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  width: auto;\n  margin-top: 10px;\n  > ul li {\n    text-align: left;\n  }\n"])), function (props) {
  return props.color;
});
StyledModalDescription.displayName = 'Modal Description';
var StyledModalButton = styled(Button)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n"])));
StyledModalButton.displayName = 'Modal Button';
export { StyledInnerWrapper, StyledModalTitle, StyledModalDescription, StyledModalButton };